// extracted by mini-css-extract-plugin
export default {"shine":"exsHUqIDxwLRwGjqOPoA"};